import { Component } from '@angular/core';

@Component({
	selector: 'initializing-spinner',
	templateUrl: './InitializingSpinner.Component.html'
})
export class InitializingSpinnerComponent {}
